import request from '@/utils/request'
import { isEmpty } from 'lodash'
// import storage from 'store'
// import { ACCESS_TOKEN } from '@/store/mutation-types'


export function selfRequest_getSchoolDetail (params) {
  params = isEmpty(params) ? {} : params
  return request({
    method: 'post',
    params: params,
    url:process.env.VUE_APP_API_detail
  })
}


export function getClassify (params) {
  params = isEmpty(params) ? {} : params
  return request({
    method: 'get',
    params: params,
    url:process.env.VUE_APP_API_classify
  })
}

export function getArticle (params) {
  params = isEmpty(params) ? {} : params
  return request({
    method: 'get',
    params: params,
    url:process.env.VUE_APP_API_article
  })
}